import * as React from 'react';
/**
 * @hidden
 */
export function useDropdownWidth(elementRef, initialStyleWidth, args) {
    var _a = React.useState(initialStyleWidth), width = _a[0], setWidth = _a[1];
    React.useEffect(function () {
        if (width !== undefined && elementRef.current) {
            setWidth(elementRef.current.offsetWidth);
        }
    }, args);
    return width;
}
//# sourceMappingURL=useDropdownWidth.js.map